import { render, staticRenderFns } from "./ActivityNav.vue?vue&type=template&id=23b187c4&scoped=true"
import script from "./ActivityNav.vue?vue&type=script&lang=js"
export * from "./ActivityNav.vue?vue&type=script&lang=js"
import style0 from "./ActivityNav.vue?vue&type=style&index=0&id=23b187c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b187c4",
  null
  
)

export default component.exports